<template>
  <div v-if="$can(constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_LISTE)">
    <edit-beneficiary
      :data-to-show="isPopupEditBeneficiaryDisplayed"
      @showChange="
        (val) => {
          changeStateEditBeneficiaryPopup(val);
        }
      "
    />
    <edit-beneficiary-rights
      :data-to-show="isPopupEditRightsDisplayed"
      @showChange="
        (val) => {
          changeStateEditRightsPopup(val);
        }
      "
    />
    <edit-beneficiary-templates
      :data-to-show="isPopupEditTemplatesDisplayed"
      @showChange="
        (val) => {
          changeStateEditTemplatesPopup(val);
        }
      "
    />

    <!-- BEGIN add new + search + sort -->
    <div
      class="flex content-center items-center justify-between my-15 2xl:my-20 m-5 lg:mx-15 2xl:mx-20"
      @keydown="onKeyDown"
      @keyup="onKeyUp"
    >
      <div class="flex flex-col lg:flex-row items-center justify-center lg:justify-between mt-5 w-full gap-y-4">
        <div
          class="w-2/3 lg:w-1/3"
        >
          <search-bar
            name="searchBeneficiary"
            libelle=""
            :value="search_beneficiary"
            placeholder="Rechercher un bénéficiaire"
            :big="false"
            :inherits="false"
            :has-border="false"
            @input="
              (newValue) => {
                search_beneficiary = newValue;
              }
            "
          />
        </div>


        <!-- BEGIN Search engine and alphabetic order -->
        <sort-button
          :sort="sort"
          @sorted="
            (sortType) => {
            changeSortType(sortType);
            }
          "
        />
        <!-- END Search engine and alphabetic order -->
      </div>
    </div>
    <!-- END add new + search + sort -->

    <list-grid :list-items="beneficiaries">
      <template #header v-if="beneficiaries.length > 0">
        <div class="col-start-1 xl:col-start-2 col-span-4 xl:col-span-3 ml-5 md:ml-10 xl:ml-0">
          Bénéficiaires
        </div>
        <div class="col-span-3 xl:col-span-3 text-center">
          Compte<span class="hidden xl:inline-block">&nbsp;bénéficiaire </span>
        </div>
        <div class="col-span-2">
          Droits<span class="hidden xl:inline-block">&nbsp; d'accès</span>
        </div>
        <div class="col-span-3  mr-5 md:mr-10">
          Modèles<span class="hidden xl:inline-block">&nbsp; de pages </span>
        </div>
      </template>
      <template #errorCases>
        <!-- <div
          v-if="beneficiaries.length > 0 && beneficiariesSort.length === 0"
          class="flex flex-col justify-center items-center w-full"
        >
          <h3
            class="text-pink-600 w-full text-center font-semibold text-lg mt-12"
          >
            Aucun résultat !
          </h3>
          <h4 class="text-indigo-600 w-4/6 text-center text-base mt-8 mb-16">
            Aucun bénéficiaire ne correspond à votre recherche, veuillez
            réessayer avec de nouveaux éléments
          </h4>
          <div>
            <illustration name="no_result" />
          </div>
        </div> -->

        <div
          v-if="beneficiaries.length === 0"
          class="flex flex-col justify-center items-center w-full"
        >
          <h3
            class="text-pink-600 w-full text-center font-semibold text-lg mt-12"
          >
            Aucun bénéficiaire
          </h3>
          <h4 class="text-indigo-600 w-4/6 text-center text-base mt-8 mb-16">
            Il n'y a aucun bénéficiaire trouvé
          </h4>
          <div>
            <illustration name="no_result" />
          </div>
        </div>
      </template>

      <!-- BEGIN list of referents -->
      <template #accordionDescription="{ item }">
        <div class="hidden xl:inline-block col-span-1 ml-5">
          <ProfilePicture size="max-w-10 w-10 h-10" :other-object="item" />
        </div>
        <div
          class="col-span-4 xl:col-span-3 place-self-center justify-self-start text-lg text-grey-900 ml-5 md:ml-10 xl:ml-0"
        >
          <!-- Bénéficiaire -->
          {{ item.firstname }}
          <span class="uppercase">{{ item.lastname }}</span>
        </div>

        <div
          class="col-span-3 xl:col-span-3 place-self-center justify-self-center"
        >
          <!-- Modifier compte -->
          <action-button
            v-if="$can(constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_EDITER)"
            border-color="border-transparent"
            text-color="text-gray-900"
            bg-color="bg-pink-300"
            bg-color-square="bg-pink-100"
            icon-color="text-pink-600"
            libelle="Compte bénéficiaire"
            :responsive="true"
            icon="edit"
            @clickAction="displayEditBeneficiaryPopup(item)"
          />
        </div>
        <div class="col-span-2 place-self-center justify-self-start">
          <!-- Modifier droits d'accès -->
          <action-button
            v-if="$can(constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_DROITS)"
            border-color="border-transparent"
            text-color="text-gray-900"
            bg-color="bg-teal-300"
            bg-color-square="bg-teal-100"
            icon-color="text-teal-600"
            libelle="Droits d'accès"
            :responsive="true"
            icon="layers"
            @clickAction="displayEditRightsPopup(item)"
          />
        </div>
        <!-- Modifier modèles de pages -->
        <div
          v-if="
            $can(
              constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_MODELE_DE_PAGE
            )
          "
          class="col-span-3 place-self-center justify-self-start  mr-5 md:mr-10"
        >
          <span>
            <action-button
              border-color="border-transparent"
              text-color="text-gray-900"
              bg-color="bg-indigo-300"
              bg-color-square="bg-indigo-200"
              icon-color="text-indigo-600"
              libelle="Modèles de pages"
              :responsive="true"
              icon="file-add"
              @clickAction="displayEditTemplatesPopup(item)"
            />
          </span>
        </div>
      </template>
      <!-- END list of referents -->
    </list-grid>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import ActionButton from './../../components/ActionButton';
import Illustration from './../../components/Illustration';
import SortButton from './../../components/SortButton';
import SearchBar from './../../components/Inputs/SearchBar.vue';

import EditBeneficiary from './popup/EditBeneficiary';
import EditBeneficiaryRights from './popup/EditBeneficiaryRights';
import EditBeneficiaryTemplates from './popup/EditBeneficiaryTemplates';
import ProfilePicture from './../../components/ProfilePicture.vue';

import ListGrid from './../../components/AccordionTable/ListGrid.vue';

import Constants from './../../constants';

export default {
  name: 'Beneficiaries',

  components: {
    ProfilePicture,
    ActionButton,
    Illustration,
    EditBeneficiary,
    EditBeneficiaryRights,
    EditBeneficiaryTemplates,
    SortButton,
    SearchBar,
    ListGrid,
  },

  data() {
    return {
      isPopupEditBeneficiaryDisplayed: false,
      isPopupEditRightsDisplayed: false,
      isPopupEditTemplatesDisplayed: false,

      search_beneficiary: '',
      sort: 'ABC',
      searchTypingInterval: 500,
      perPage: 10,

      constants: Constants,
    };
  },

  mounted() {
    this.getNextNeopassOnScroll();
  },

  methods: {
    ...mapMutations({
      SET_SAVING: 'permissions/SET_SAVING',
      SET_ERRORS: 'permissions/SET_ERRORS',
      SET_BENEFICIARYTOEDIT: 'beneficiaries/SET_BENEFICIARYTOEDIT',

      SET_URLCURSOR: 'beneficiaries/SET_URLCURSOR',
    }),

    ...mapActions({
      loadBeneficiaries: 'beneficiaries/loadBeneficiaries',
      loadBeneficiaryRights: 'beneficiaries/loadBeneficiaryRights',
      loadBeneficiaryTemplates: 'beneficiaries/loadBeneficiaryTemplates',
    }),

    initEmptyReferent() {
      this.newEmptyReferent = {
        id: null,
        firstname: '',
        lastname: '',
        username: '',
        email: '',
        function: '',
        company: '',
        password: '',
        telephone: '',
        address: '',
        role: null,
      };
    },

    initStatus() {
      setTimeout(() => {
        this.SET_BENEFICIARYTOEDIT({});
      }, 200);
      this.SET_SAVING(false);
      this.SET_ERRORS(null);
    },

    changeStateEditBeneficiaryPopup(state) {
      this.isPopupEditBeneficiaryDisplayed = state;
      if (!state) {
        this.initStatus();
      }
    },

    displayEditBeneficiaryPopup(beneficiary) {
      this.isPopupEditBeneficiaryDisplayed = true;
      this.beneficiaryToEdit.password = '';

      this.SET_BENEFICIARYTOEDIT(beneficiary);
    },

    changeStateEditRightsPopup(state) {
      this.isPopupEditRightsDisplayed = state;
      if (!state) {
        this.initStatus();
      }
    },

    async displayEditRightsPopup(beneficiary) {
      await this.loadBeneficiaryRights(beneficiary.id).then((response) => {
        let b = { ...beneficiary };
        b.rights = response;
        this.SET_BENEFICIARYTOEDIT(b);

        this.isPopupEditRightsDisplayed = true;
      });
    },

    changeStateEditTemplatesPopup(state) {
      this.isPopupEditTemplatesDisplayed = state;
      if (!state) {
        this.initStatus();
      }
    },

    async displayEditTemplatesPopup(beneficiary) {
      await this.loadBeneficiaryTemplates(beneficiary.id).then((response) => {
        this.SET_BENEFICIARYTOEDIT(beneficiary);
        this.beneficiaryToEdit.templates = response;
        this.isPopupEditTemplatesDisplayed = true;
      });
    },

    onKeyDown() {
      clearTimeout(this.timer);
    },

    onKeyUp() {
      clearTimeout(this.timer);
      this.timer = setTimeout(this.doneTyping, this.searchTypingInterval);
    },

    doneTyping() {
      //reset cursor for init pagination
      this.SET_URLCURSOR('');
      this.loadBeneficiaries({
        hasPagination: 1,
        search: this.search_beneficiary,
        orderBy: this.orderBy,
        direction: this.direction,
        perPage: this.perPage,
      });
    },

    nextBeneficiaries() {
      this.loadBeneficiaries({
        hasPagination: 1,
        search: this.search_beneficiary,
        orderBy: this.orderBy,
        direction: this.direction,
        perPage: this.perPage,
      });
    },

    /**
     * Pagination with infinite scroll
     */
    getNextNeopassOnScroll() {
      let mainContent = document.getElementById('main-content');

      mainContent.onscroll = () => {
        let bottomOfWindow =
          mainContent.scrollTop + mainContent.offsetHeight ===
          mainContent.scrollHeight;

        if (bottomOfWindow && this.$route.name === 'PermissionsBeneficiaries') {
          this.nextBeneficiaries();
        }
      };
    },

    changeSortType(sortType) {
      this.SET_URLCURSOR('');
      this.sort = sortType;

      this.loadBeneficiaries({
        hasPagination: 1,
        search: this.search_beneficiary,
        orderBy: this.orderBy,
        direction: this.direction,
        perPage: this.perPage,
      });
    },

    changePerPage(numberPages) {
      this.SET_URLCURSOR('');
      this.perPage = numberPages;

      this.loadBeneficiaries({
        hasPagination: 1,
        search: this.search_beneficiary,
        orderBy: this.orderBy,
        direction: this.direction,
        perPage: this.perPage,
      });
    },
  },

  computed: {
    ...mapGetters({
      beneficiaries: 'beneficiaries/beneficiaries',
      beneficiaryToEdit: 'beneficiaries/beneficiaryToEdit',
    }),

    orderBy() {
      switch (this.sort) {
        case 'ABC':
        case 'ZYX':
          return 'lastname';

        case 'JAN':
        case 'DEC':
          return 'created_at';
        default:
          return 'lastname';
      }
    },

    direction() {
      switch (this.sort) {
        case 'ABC':
        case 'JAN':
          return 'ASC';

        case 'ZYX':
        case 'DEC':
          return 'DESC';
        default:
          return 'ASC';
      }
    },
  },
};
</script>
